export enum ProjectTag {
  Frontend = 'Frontend',
  Backend = 'Backend',
  Personal = 'Personal',
  FullStack = 'Full-stack',
  OpenSource = 'Open Source',
  ChromeExtension = 'Chrome Extension',
  MobileApp = 'Mobile App',
}
